"use strict";

const State = {
  state: function () {
    return {
      visible: false,
      message: '',
      error: '',
      buttons: null,
      click: null
    };
  }
};

module.exports = State;



// WEBPACK FOOTER //
// ./src/components/common/messageBox/state.js